import { render, staticRenderFns } from "./InfoConfigProblemList.vue?vue&type=template&id=4af96756&scoped=true&"
import script from "./InfoConfigProblemList.vue?vue&type=script&lang=ts&"
export * from "./InfoConfigProblemList.vue?vue&type=script&lang=ts&"
import style0 from "./InfoConfigProblemList.vue?vue&type=style&index=0&id=4af96756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af96756",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
